import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import styles from "./PlatformHubSection.module.scss";

export type IPlatformHubSectionProps = {
	title?: string;
	subtitle?: string;
	className?: string;
	children: React.ReactNode;
};
const PlatformHubSection = ({ title, subtitle, className, children }: IPlatformHubSectionProps) => {
	return (
		<Box className={clsx(styles.platformSectionContainer, className)}>
			{(title || subtitle) && (
				<>
					<Box className={styles.platformSectionHeader}>
						{title && <Typography className={styles.title}>{title}</Typography>}
						{subtitle && <Typography className={styles.subtitle}>{subtitle}</Typography>}
					</Box>
				</>
			)}
			{children}
		</Box>
	);
};

export default PlatformHubSection;
